import React from 'react';
import { X, Info } from 'lucide-react';

/**
 * SidePanel - Left Side Drawer pentru afișarea detaliilor hărții
 * Imagine STATICĂ (fără zoom) - doar preview
 */
const SidePanel = ({ activeMap, onClose }) => {
  if (!activeMap) return null;

  const formatRegionName = (region) => {
    if (!region) return 'Necunoscut';
    const regionMap = {
      'moldova': 'Moldova', 'tara-romaneasca': 'Țara Românească',
      'transilvania': 'Transilvania', 'banat': 'Banat',
      'dobrogea': 'Dobrogea', 'bulgaria': 'Bulgaria',
      'dacia': 'Dacia', 'europa': 'Europa', 'grecia': 'Grecia',
      'ungaria': 'Ungaria', 'italia': 'Italia', 'turcia': 'Turcia',
      'lumea antica': 'Lumea Antică', 'imperiu otoman': 'Imperiul Otoman'
    };
    return regionMap[region.toLowerCase().trim()] || 
           region.charAt(0).toUpperCase() + region.slice(1).replace(/-/g, ' ');
  };

  return (
    <div 
      className="side-panel-container"
      data-testid="side-panel"
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-3 right-3 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg hover:shadow-xl transition-all hover:scale-105 border border-gray-200"
        data-testid="side-panel-close"
        aria-label="Închide panoul"
      >
        <X className="w-6 h-6 text-gray-700" />
      </button>

      {/* Header */}
      <div className="px-4 pt-4 pb-3 border-b border-gray-200">
        <h1 
          className="text-xl md:text-2xl font-bold text-gray-900 leading-tight pr-12 font-serif"
          data-testid="side-panel-title"
        >
          {activeMap.title}
        </h1>
        
        {activeMap.subtitle && (
          <p className="text-sm text-gray-500 italic mt-1">
            {activeMap.subtitle}
          </p>
        )}

        <div className="mt-2 text-sm text-gray-600 space-y-0.5">
          {activeMap.author && (
            <p><span className="font-semibold">Autor:</span> {activeMap.author} &nbsp; <span className="font-semibold">An:</span> {activeMap.year}</p>
          )}
          <p><span className="font-semibold">Regiune:</span> {formatRegionName(activeMap.region)}</p>
        </div>
      </div>

      {/* Map Image - STATIC, no zoom controls */}
      <div className="px-4 py-4">
        <div className="overflow-hidden rounded-lg border border-gray-300 shadow-md bg-[#f5f3ef]">
          <img
            src={activeMap.imageUrl || '/hero-bg-new.png'}
            alt={activeMap.title}
            className="w-full h-auto object-contain"
            style={{ maxHeight: '280px' }}
            onError={(e) => { e.target.src = '/hero-bg-new.png'; }}
            draggable={false}
          />
        </div>
      </div>

      {/* Description - uses fullDescription if available (like MapModal) */}
      {(activeMap.fullDescription || activeMap.description || activeMap.descriptionPreview) && (
        <div className="px-4 py-3 border-t border-gray-200 flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Info className="w-4 h-4 text-gray-500" />
            <h3 className="text-base font-bold text-gray-900 font-serif">Descriere</h3>
          </div>
          <div className="text-sm text-gray-700 leading-relaxed text-justify whitespace-pre-line">
            {activeMap.fullDescription || activeMap.description || activeMap.descriptionPreview}
          </div>
        </div>
      )}

      {/* Bottom padding */}
      <div className="h-4"></div>

      <style>{`
        .side-panel-container {
          position: relative;
          width: 100%;
          height: 100vh;
          max-height: 100vh;
          background: #ffffff;
          overflow-y: auto;
          overflow-x: hidden;
          display: flex;
          flex-direction: column;
          /* Enable smooth scrolling */
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          /* Ensure scroll works with mouse wheel */
          overscroll-behavior: contain;
        }

        .side-panel-container::-webkit-scrollbar {
          width: 6px;
        }

        .side-panel-container::-webkit-scrollbar-track {
          background: #f5f5f5;
          border-radius: 3px;
        }

        .side-panel-container::-webkit-scrollbar-thumb {
          background: #d4af37;
          border-radius: 3px;
        }

        .side-panel-container::-webkit-scrollbar-thumb:hover {
          background: #b8972e;
        }
      `}</style>
    </div>
  );
};

export default SidePanel;
